export const customModalStyle = {
  content: {
    borderRadius: '16px',
  },
}
